// Pasted addresses often carry stray spaces. Non-strings pass through so an
// untouched null email round-trips unchanged.
export function normalizeEmail(email) {
  return typeof email === 'string' ? email.replace(/\s+/g, '').toLowerCase() : email;
}
